import keyNames from "../../keyName";
export const initialState = {
  [keyNames.themeMode]: "light",
  [keyNames.apiErrors]: null,
  [keyNames.extra]: null,
  [keyNames.isLoading]: "noLoading",
  [keyNames.toastData]: null,
  [keyNames.userData]: null,
  [keyNames.forceLogOut]: false,
  [keyNames.registeredUserData]: null,
  [keyNames.widgetData]: null,
  [keyNames.blogData]: null,
  [keyNames.caseStudyData]: null,
  [keyNames.prArticleData]: null,
  [keyNames.menuArticleData]: null,
  [keyNames.categoryData]: null,
};
